import { render, staticRenderFns } from "./LoginReferenceText.vue?vue&type=template&id=41573fda&scoped=true&"
import script from "./LoginReferenceText.vue?vue&type=script&lang=js&"
export * from "./LoginReferenceText.vue?vue&type=script&lang=js&"
import style0 from "./LoginReferenceText.vue?vue&type=style&index=0&id=41573fda&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41573fda",
  null
  
)

export default component.exports